import React from 'react';
import { HiOutlineChevronRight } from 'react-icons/hi';

export const TransactionActivity = ({ transaction }) => {
  const upcomingActivities = transaction?.upcomingActivities || [];

  return (
    <div className="my-6 bg-white/30 backdrop-blur-md border border-white/20 rounded-xl p-5 shadow-lg">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <h2 className="text-lg font-semibold text-gray-100">Activity</h2>
          {upcomingActivities.length > 0 && (
            <span className="text-xs bg-blue-200 text-blue-800 px-2 py-0.5 rounded-full font-medium">
              {upcomingActivities.length}
            </span>
          )}
        </div>

        <button className="flex items-center text-sm text-blue-200 hover:underline">
          View All Activity <HiOutlineChevronRight className="ml-1 w-4 h-4" />
        </button>
      </div>

      <div className="space-y-3">
        {upcomingActivities.length === 0 ? (
          <p className="text-sm text-gray-300">
            No records found for this transaction.
          </p>
        ) : (
          upcomingActivities.map((activity, idx) => (
            <div
              key={idx}
              className="bg-white/40 backdrop-blur-sm border border-white/30 rounded-md px-4 py-3 flex justify-between items-start transition hover:bg-white/50"
            >
              <div>
                <p className="text-sm font-medium text-gray-800">
                  {activity.title}
                </p>
                <p className="text-xs text-gray-600">
                  {activity.date} — {activity.description}
                </p>
              </div>
              <span className="text-xs text-gray-500">{activity.time}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
